<template>
    <ul class="space-y-1">
        <li v-for="node in nodes" :key="node.id" class="transition-colors duration-200 hover:bg-gray-50 rounded-md">
            <div class="flex items-center space-x-3 py-2" :style="{ paddingLeft: (depth * 20) + 'px' }">
                <input
                        type="checkbox"
                        class="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                        :checked="node.enabled"
                        @change="toggle(node)"
                        :id="'node-' + node.id"
                />
                <label
                        :for="'node-' + node.id"
                        class="flex-1 cursor-pointer select-none"
                        :class="{
            'font-semibold text-gray-800 text-sm': node.children && node.children.length,
            'text-gray-600 text-sm': !(node.children && node.children.length),
            'text-indigo-700': depth === 0
          }"
                >
                    {{ node.label }}
                </label>
            </div>

            <div v-if="node.children && node.children.length > 0">
                <PermissionTree
                        :nodes="node.children"
                        :depth="depth + 1"
                        @toggle="$emit('toggle', $event)"
                />
            </div>
        </li>
    </ul>
</template>

<script>
    export default {
        name: "PermissionTree",
        props: {
            nodes: {
                type: Array,
                required: true,
            },
            depth: {
                type: Number,
                default: 0
            }
        },
        methods: {
            toggle(node) {
                // Utiliser Vue.set pour la réactivité dans Vue 2
                //this.$set(node, 'enabled', !node.enabled);

                node['enabled']=!node.enabled


                this.$emit('toggle', node);
            }
        }
    };
</script>

<style scoped>
    .form-checkbox {
        border-radius: 0.25rem;
    }

    .form-checkbox:checked {
        background-color: #4f46e5;
        border-color: #4f46e5;
    }

    .form-checkbox:focus {
        ring: 2px;
        ring-color: #4f46e5;
    }
</style>